// cfgtables

const state = {
	cfgreftables: [],
	cfglists: [],
	cfgforms: {},
	
};

export default state;